import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Button, Box, Typography } from "@mui/material";
import Modal from "../../../../components/Modal";
import { useTranslation } from "react-i18next";
import { GoogleMap } from "../../../../components/GoogleMap/GoogleMap";
import { useTrainingLocationCoordinates } from "../../../../hooks/trainingLocations";
import Skeleton from "../../../../components/Skeleton/Skeleton";
import LoadingButton from "../../../../components/Buttons/LoadingButton";

const ConfirmLocationModal = ({
  onClose,
  location,
  open,
  onConfirm,
  isSubmitting
}) => {
  const { t } = useTranslation();
  const { getCoordinates, isLoading } = useTrainingLocationCoordinates(
    location
  );

  const [coordinates, setCoordinates] = useState(null);

  useEffect(() => {
    if (open) {
      getCoordinates(location).then(setCoordinates);
    }
  }, [open]);

  const handleClose = () => {
    setCoordinates(null);
    onClose();
  };

  const handleConfirm = () => {
    onConfirm(coordinates);
    handleClose();
  };

  return (
    <Modal
      maxWidth="md"
      fullWidth
      fillHeight
      dialogTitle={
        <Typography variant="h5" color="textPrimary">
          {t("manageCourses.confirmAddressLocation")}
        </Typography>
      }
      dialogContent={
        <Box display="flex" flexDirection="column" pb={2} height="100%">
          <Typography variant="subtitle1" sx={{ mb: 3 }}>
            {t("manageCourses.confirmAddressQuestion")}
          </Typography>
          {!!coordinates ? (
            <Box height="100%" position="relative" mb={2}>
              <GoogleMap
                lat={coordinates.latitude}
                lng={coordinates.longitude}
              />
            </Box>
          ) : (
            <Skeleton height="100%" width="100%" mb={2} loading />
          )}
        </Box>
      }
      dialogActions={
        <>
          <Button color="primary" onClick={handleClose} disabled={isSubmitting}>
            {t("manageCourses.confirmAddressCancelBtn")}
          </Button>
          <LoadingButton
            pending={isSubmitting}
            color="primary"
            variant="contained"
            onClick={handleConfirm}
            disabled={isSubmitting || isLoading}
            data-qa="confirm-location-modal-save-btn"
          >
            {t("saveBtn")}
          </LoadingButton>
        </>
      }
      open={open}
      onClose={handleClose}
      showCloseIcon
      data-qa="confirm-location-modal"
    />
  );
};

ConfirmLocationModal.propTypes = {
  /**
   * Called to close the Add Course Version Modal
   */
  onClose: PropTypes.func,
  /**
   * True if the modal is open, false otherwise
   */
  open: PropTypes.bool,
  /**
   * Called when the confirm location button is clicked
   */
  onConfirm: PropTypes.func,
  location: PropTypes.shape({
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string
  })
};

export default ConfirmLocationModal;
